// Paleta de cores do dashboard (estilo do painel de BI: ciano/verde/roxo/amarelo)
export const COLORS = [
  "#2ab7ce", // ciano
  "#3fc79a", // verde-água
  "#5b6bb5", // indigo
  "#f6c343", // amarelo
  "#e05c6e", // vermelho/rosa
  "#8e6fc4", // roxo
  "#2e4664", // navy
  "#fd985d", // laranja
  "#33b1e0", // azul
  "#9aa7bd", // cinza
];

export function moneyBR(v) {
  return (Number(v) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function numberBR(v) {
  return (Number(v) || 0).toLocaleString("pt-BR");
}

const MONTHS_PT = [
  "jan", "fev", "mar", "abr", "mai", "jun",
  "jul", "ago", "set", "out", "nov", "dez",
];

// Encurta labels de eixo X de data:
//  "2026-01-27" -> "27/01"   |   "2026-06" -> "jun/26"
// Mantém qualquer outra string (categorias) intacta.
export function shortLabel(value) {
  if (typeof value !== "string") return value;
  let m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}/${m[2]}`;
  m = value.match(/^(\d{4})-(\d{2})$/);
  if (m) {
    const mon = MONTHS_PT[Number(m[2]) - 1] || m[2];
    return `${mon}/${m[1].slice(2)}`;
  }
  return value;
}

// Config de ticks reutilizável para eixos X de data.
export const dateTicks = {
  autoSkip: true,
  maxRotation: 45,
  minRotation: 0,
  maxTicksLimit: 10,
  callback: (v) => shortLabel(v),
};

// Ordena e retorna os valores distintos de um eixo (ex: year_month)
function distinctSorted(rows, key) {
  return [...new Set(rows.map((r) => r[key]))].sort();
}

/**
 * Agrupa linhas num gráfico multi-série por categoria.
 * Ex: rows=[{year_month, type, total}] -> uma série por `type`.
 */
export function groupSeries(rows, xKey, catKey, valKey, opts = {}) {
  const labels = distinctSorted(rows, xKey);
  const cats = [...new Set(rows.map((r) => r[catKey]))];
  const datasets = cats.map((cat, i) => {
    const color = COLORS[i % COLORS.length];
    return {
      label: cat == null ? "—" : String(cat),
      data: labels.map((l) => {
        const found = rows.find((r) => r[xKey] === l && r[catKey] === cat);
        return found ? Number(found[valKey]) : 0;
      }),
      backgroundColor: color,
      borderColor: color,
      fill: false,
      ...opts,
    };
  });
  return { labels, datasets };
}

/**
 * Uma única série a partir de um array de linhas.
 */
export function singleSeries(rows, xKey, valKey, label, colorIdx = 0, opts = {}) {
  const color = COLORS[colorIdx % COLORS.length];
  return {
    labels: rows.map((r) => r[xKey]),
    datasets: [
      {
        label,
        data: rows.map((r) => Number(r[valKey])),
        backgroundColor: color,
        borderColor: color,
        fill: false,
        ...opts,
      },
    ],
  };
}

/**
 * Donut a partir de pares label/valor.
 */
export function doughnut(items, labelKey, valueKey) {
  return {
    labels: items.map((i) => i[labelKey]),
    datasets: [
      {
        data: items.map((i) => Number(i[valueKey])),
        backgroundColor: items.map((_, i) => COLORS[i % COLORS.length]),
        borderWidth: 1,
      },
    ],
  };
}

export const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { position: "bottom" },
  layout: { padding: { top: 18, right: 8 } },
  scales: {
    xAxes: [{ ticks: dateTicks }],
    yAxes: [{ ticks: { beginAtZero: true } }],
  },
};
